import { SERVICES } from '../actions/services';

const initialState = {
  services: {
    list: [],
    filteredList: [],
    state: undefined
  },
  parentGroups: {
    parentGroups: [],
    filteredList: [],
    state: undefined
  },
  fetchDetails: {
    serviceDetails: { services: [] },
    serviceKey: undefined,
    state: undefined
  },
  add_edit: {
    list: [],
    state: undefined
  },
  categories: {
    list: [],
    loaded: false,
    loading: false
  },
  servicesList: {
    list: [],
    loaded: false,
    loading: false,
    loadingMore: false,
    currentPage: 1,
    hasMore: false
  },
  providersList: {
    list: [],
    loaded: false,
    loading: false,
    loadingMore: false,
    currentPage: 1,
    hasMore: false
  },
  snackBar: { show: false, message: '' },
  deleteServiceModal: {
    show: false,
    serviceDetails: { services: [] }
  }
};

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case SERVICES.FETCH.LOAD:
      return {
        ...state,
        services: {
          list: [],
          filteredList: [],
          state: SERVICES.FETCH.LOAD,
          loaded: false
        },
        snackBar: { show: false, message: '' }
      };

    case SERVICES.FETCH.SUCCESS: {
      return {
        ...state,
        services: {
          list: payload.services,
          filteredList: payload.services,
          state: SERVICES.FETCH.SUCCESS,
          loaded: true
        }
      };
    }

    case SERVICES.FETCH.FAIL:
      return {
        ...state,
        services: {
          list: [],
          filteredList: [],
          state: SERVICES.FETCH.FAIL,
          loaded: false
        }
      };

    case SERVICES.FETCH_PARENT_GROUP.LOAD:
      return {
        ...state,
        parentGroups: {
          parentGroups: [],
          filteredList: [],
          state: SERVICES.FETCH_PARENT_GROUP.LOAD,
          loaded: false
        }
      };

    case SERVICES.FETCH_PARENT_GROUP.SUCCESS: {
      return {
        ...state,
        parentGroups: {
          parentGroups: payload.parentGroups,
          filteredList: payload.parentGroups,
          state: SERVICES.FETCH_PARENT_GROUP.SUCCESS,
          loaded: true
        }
      };
    }

    case SERVICES.FETCH_PARENT_GROUP.FAIL:
      return {
        ...state,
        parentGroups: {
          parentGroups: [],
          filteredList: [],
          state: SERVICES.FETCH_PARENT_GROUP.FAIL,
          loaded: false
        }
      };

    case SERVICES.FETCH_DETAILS.LOAD:
      return {
        ...state,
        fetchDetails: {
          serviceDetails: { services: [] },
          serviceKey: payload.serviceKey,
          state: SERVICES.FETCH_DETAILS.LOAD
        }
      };

    case SERVICES.FETCH_DETAILS.SUCCESS: {
      return {
        ...state,
        fetchDetails: {
          ...state.fetchDetails,
          serviceDetails: payload.serviceDetails,
          state: SERVICES.FETCH_DETAILS.SUCCESS
        }
      };
    }

    case SERVICES.FETCH_DETAILS.FAIL:
      return {
        ...state,
        fetchDetails: {
          ...state.fetchDetails,
          serviceDetails: { services: [] },
          state: SERVICES.FETCH_DETAILS.FAIL
        }
      };

    case SERVICES.ADD_EDIT.LOAD:
      return {
        ...state,
        add_edit: {
          list: [],
          filteredList: [],
          state: SERVICES.ADD_EDIT.LOAD
        }
      };

    case SERVICES.ADD_EDIT.SUCCESS: {
      return {
        ...state,
        add_edit: {
          list: payload.services,
          filteredList: payload.services,
          state: SERVICES.ADD_EDIT.SUCCESS
        },
        snackBar: { show: true, message: 'Service Saved successfully' }
      };
    }

    case SERVICES.ADD_EDIT.FAIL:
      return {
        ...state,
        add_edit: {
          list: [],
          filteredList: [],
          state: SERVICES.ADD_EDIT.FAIL
        }
      };

    case SERVICES.ADD_EDIT.CONFLICT: {
      return {
        ...state,
        add_edit: {
          list: [],
          filteredList: [],
          state: SERVICES.ADD_EDIT.CONFLICT
        },
        snackBar: { show: true, message: payload.error }
      };
    }

    case SERVICES.SNACK_BAR.HIDE:
      return {
        ...state,
        snackBar: {
          show: false,
          message: ''
        }
      };

    case SERVICES.MODAL.TOGGLE_DELETE: {
      return Object.assign({}, state, {
        deleteServiceModal: { show: payload.showModal, serviceDetails: { services: [] } }
      });
    }

    case SERVICES.FETCH_CATEGORIES.LOAD:
      return {
        ...state,
        categories: {
          list: [],
          loaded: false,
          loading: true
        }
      };

    case SERVICES.FETCH_CATEGORIES.SUCCESS:
      return {
        ...state,
        categories: {
          list: payload.categories,
          loaded: true,
          loading: false
        }
      };

    case SERVICES.FETCH_CATEGORIES.FAIL:
      return {
        ...state,
        categories: {
          list: [],
          loaded: false,
          loading: false
        }
      };

    case SERVICES.FETCH_SERVICES_LIST.LOAD:
      return {
        ...state,
        servicesList: {
          list: [],
          loaded: false,
          loading: true,
          loadingMore: false,
          currentPage: 1,
          hasMore: false
        }
      };

    case SERVICES.FETCH_SERVICES_LIST.SUCCESS:
      return {
        ...state,
        servicesList: {
          list: payload.services,
          loaded: true,
          loading: false,
          loadingMore: false,
          currentPage: 1,
          hasMore: payload.hasMore
        }
      };

    case SERVICES.FETCH_SERVICES_LIST.FAIL:
      return {
        ...state,
        servicesList: {
          list: [],
          loaded: false,
          loading: false,
          loadingMore: false,
          currentPage: 1,
          hasMore: false
        }
      };

    case SERVICES.FETCH_SERVICES_LIST.LOAD_MORE:
      return {
        ...state,
        servicesList: {
          ...state.servicesList,
          loadingMore: true
        }
      };

    case SERVICES.FETCH_SERVICES_LIST.LOAD_MORE_SUCCESS:
      return {
        ...state,
        servicesList: {
          ...state.servicesList,
          list: [...state.servicesList.list, ...payload.services],
          loadingMore: false,
          hasMore: payload.hasMore
        }
      };

    case SERVICES.FETCH_PROVIDERS_LIST.LOAD:
      return {
        ...state,
        providersList: {
          list: [],
          loaded: false,
          loading: true,
          loadingMore: false,
          currentPage: 1,
          hasMore: false
        }
      };

    case SERVICES.FETCH_PROVIDERS_LIST.SUCCESS:
      return {
        ...state,
        providersList: {
          list: payload.providers,
          loaded: true,
          loading: false,
          loadingMore: false,
          currentPage: 1,
          hasMore: payload.hasMore
        }
      };

    case SERVICES.FETCH_PROVIDERS_LIST.LOAD_MORE_SUCCESS:
      return {
        ...state,
        providersList: {
          ...state.providersList,
          list: [...state.providersList.list, ...payload.providers],
          loadingMore: false,
          hasMore: payload.hasMore
        }
      };

    case SERVICES.FETCH_PROVIDERS_LIST.FAIL:
      return {
        ...state,
        providersList: {
          list: [],
          loaded: false,
          loading: false,
          loadingMore: false,
          currentPage: 1,
          hasMore: false
        }
      };

    case SERVICES.FETCH_PROVIDERS_LIST.LOAD_MORE:
      return {
        ...state,
        providersList: {
          ...state.providersList,
          loadingMore: true
        }
      };

    default:
      return state;
  }
};
